import { rem } from 'polished'
import { useField, useFormikContext } from 'formik'
import get from 'lodash.get'
import { IVenueFormValues } from 'FormPage/FormPage'
import { Text } from 'components'
import {
  Input as UIInput,
  IInputProps,
} from '@nextretreat/ui-components/dist/Input'

export const Description = ({
  text,
  className,
}: {
  text: string
  className?: string
}) => (
  <Text
    className={className}
    as="p"
    textAlign="left"
    lineHeight={rem(24)}
    fontSize="s"
    mt={4}
  >
    {text}
  </Text>
)

export interface IInputFormikProps extends Omit<IInputProps, 'name'> {
  name: string
}

export const InputFormik = ({
  invalid,
  name,
  type,
  placeholder,
  ...passingProps
}: IInputFormikProps) => {
  const { errors, touched } = useFormikContext<IVenueFormValues>()
  const [field] = useField({ name: name, type, placeholder })

  return (
    <UIInput
      {...field}
      {...passingProps}
      type={type}
      placeholder={placeholder}
      invalid={invalid || !!(get(errors, name) && get(touched, name))}
    />
  )
}
